module.exports = __webpack_public_path__ + "img/bugoro_05.2ab47129.png";